import { render, staticRenderFns } from "./VisitsPast.vue?vue&type=template&id=76f1a153&"
import script from "./VisitsPast.vue?vue&type=script&lang=js&"
export * from "./VisitsPast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports